import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Certainty from "./sections/Certainty";
import Bedrock from "./sections/Bedrock";
import Specializations from "./sections/Specializations";
import Reliability from "./sections/Reliability";
import Risk from "./sections/Risk";
import Consultation from "./sections/Consultation";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Certainty />
      <Bedrock />
      <Specializations />
      <Reliability />
      <Risk />
      <Consultation />
      <Footer />
    </div>;
}